import AddNew from "./AddNew";
import List from "./List";

export default function Costs() {
    return (
        <>
        <AddNew/>
        <List/>
        </>
    )
}